import React from 'react';
import { Skeleton } from '@mui/material';

const SkeletonLoaderWrapper = ({ loading, children, skeletonProps = {} }) => {
  if (loading) {
    return (
      <Skeleton variant="text" sx={{ transform: 'none' }} {...skeletonProps}>
        {children}
      </Skeleton>
    );
  }

  return children;
};

export default SkeletonLoaderWrapper;
